// extracted by mini-css-extract-plugin
module.exports = {"loadingBox":"pageLoading_loadingBox__12gor"};